import { Box } from "@mui/system";
import React from "react";
import { SectionHeader } from "./SectionHeader";
import GenericBarGraph from "@/components/Graph/GenericBarGraph";
import type { ReferralProps } from "@/types/dashboardtypes";

export default function Referral(props: ReferralProps) {
  const { businessLabels, businessDatasets } = props;

  return (
    <Box sx={{ mt: 3, borderRadius: 2, overflow: "hidden", boxShadow: 1 }}>
      {/* Header */}
      <SectionHeader title="Referral Metrics" />

      {/* Referral Business */}
      <GenericBarGraph
        labels={businessLabels}
        datasets={businessDatasets}
        title="Business Metrics"
      />
    </Box>
  );
}
